import { useSection4 } from "./section4.hook";

export const Section4 = () => {
  const { t } = useSection4();

  const Title = (
    <h2 className="mb-5 ps-1 pe-1 section4-dynamic-size-title landing-dynamic-size-title d-flex align-item-center justify-content-center text-uppercase">
      {t("landing.section_4_title")}
    </h2>
  );
  const Subtitle = (
    <div
      className="section4-dynamic-size-subtitle text-center mx-auto px-3"
      style={{ maxWidth: "700px" }}
    >
      {t("landing.section_4_subtitle")}
    </div>
  );

  return (
    <div className="d-flex flex-column justify-content-center">
      {Title}
      {Subtitle}
    </div>
  );
};
